import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { Button } from './Button';
import { contact } from '../data/content';
import { track } from '../utils/tracking';
import type { LandingActions } from '../types/actions';
export function FinalCTA({
  onFormCta
}: Pick<LandingActions, 'onFormCta'>) {
  return <section id="final-cta" className="w-full border-y border-line bg-canvas" data-id="element-105" data-mp="844a752d8tdr">
      <div className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-20" data-id="element-106" data-mp="m4f1283oe7yx">
        <div className="max-w-3xl" data-id="element-107" data-mp="h5vf47p30w6k">
          <h2 className="font-display text-[28px] font-semibold leading-[1.1] tracking-[-0.03em] text-ink md:text-[44px]" data-id="element-108" data-mp="h6n8rcz4cju7">
            You do not have to build every system alone.
          </h2>
          <p className="mt-4 text-[16px] leading-relaxed text-ink-600 md:mt-5 md:text-[18px]" data-id="element-109" data-mp="qvf0bk09p24l">
            Your brand is worth building. Your clients deserve consistent follow-up. Your business deserves stronger
            support behind the scenes.
          </p>
        </div>

        <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-110" data-mp="2c4woipnd6ehx">
          <Button onClick={() => onFormCta('final_cta')} fullWidth className="sm:w-auto" data-id="element-111" data-mp="2c7125zb2erve">
            Start a Private Conversation
          </Button>
          <Button variant="outline" onClick={() => onFormCta('final_cta_book')} fullWidth className="sm:w-auto" data-id="element-112" data-mp="2m1svus1j0ukw">
            Book a Private Growth Call
          </Button>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-line pt-6 sm:flex-row sm:gap-8" data-id="element-113" data-mp="2v4amdio7s9dp">
          <a href={`tel:${contact.phone}`} onClick={() => track('phone_click', {
          location: 'final_cta'
        })} className="flex items-center gap-2 text-[15px] font-medium text-ink transition-colors duration-150 ease-smooth hover:text-accent" data-id="element-114" data-mp="301tzgf96eg42">
            <PhoneIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-115" data-mp="3errosyiudbuu" />
            Call or text: {contact.phone}
          </a>
          <a href={`mailto:${contact.email}`} className="flex items-center gap-2 text-[15px] font-medium text-ink transition-colors duration-150 ease-smooth hover:text-accent" data-id="element-116" data-mp="3itwk01oxugjl">
            <MailIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-117" data-mp="1eqtmvmwdx38t" />
            Email: {contact.email}
          </a>
        </div>
      </div>
    </section>;
}